module.exports = __webpack_public_path__ + "static/media/album.dfa46f32.svg";